module.exports = __webpack_public_path__ + "img/by-activity2.c8c1e0ba.svg";